import { render, staticRenderFns } from "./GetInTouch.vue?vue&type=template&id=73ef991b&"
import script from "./GetInTouch.vue?vue&type=script&lang=js&"
export * from "./GetInTouch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GetInTouch.vue"
export default component.exports